/* =========================================
   MUBLIG Menu
   Datei: assets/mublig-menu.js

   Funktionen:
   - Mega-Menü Position unter Navigation setzen
   - offene Hauptmenüs gegenseitig schließen
   - aktive Räume im Mega-Menü steuern
   ========================================= */

(function () {
  if (window.__mubligMenuLoaded) return;
  window.__mubligMenuLoaded = true;

  var SELECTORS = {
    topDetails: '.header__menu > ul > li > details[level="top"]',
    mega: '.mublig-mega',
    room: '.mublig-mega__room',
    nav: '.mublig-header__nav',
    header: '.mublig-header',
    headerMenu: '.header__menu'
  };

  var resizeTimer = null;

  function setMegaMenuTop() {
    var nav = document.querySelector(SELECTORS.nav);
    var header = document.querySelector(SELECTORS.header);
    var target = nav || header;

    if (!target) return;

    var rect = target.getBoundingClientRect();
    var bottom = Math.round(rect.bottom);

    document.documentElement.style.setProperty('--mublig-mega-top', bottom + 'px');
  }

  function closeSingleDetails(details) {
    if (!details) return;

    details.removeAttribute('open');
    details.open = false;

    var summary = details.querySelector(':scope > summary');

    if (summary) {
      summary.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }
  }

  function closeDetails(details) {
    if (!details) return;

    closeSingleDetails(details);

    details.querySelectorAll('details').forEach(function (childDetails) {
      closeSingleDetails(childDetails);
    });
  }

  function closeSiblingMenus(currentDetails) {
    document.querySelectorAll(SELECTORS.topDetails).forEach(function (details) {
      if (details !== currentDetails) {
        closeDetails(details);
      }
    });
  }

  function activateMegaRoom(room) {
    var mega = room.closest(SELECTORS.mega);

    if (!mega) return;

    mega.classList.add('has-active');

    mega.querySelectorAll(SELECTORS.room).forEach(function (item) {
      item.classList.toggle('is-active', item === room);
    });
  }

  function resetMegaRooms(mega) {
    if (!mega) return;

    mega.classList.remove('has-active');

    mega.querySelectorAll(SELECTORS.room).forEach(function (item) {
      item.classList.remove('is-active');
    });
  }

  function bindTopMenuEvents() {
    document.querySelectorAll(SELECTORS.topDetails).forEach(function (details) {
      if (details.dataset.mubligTopBound === 'true') return;

      details.dataset.mubligTopBound = 'true';

      function handleOpenIntent() {
        setMegaMenuTop();
        closeSiblingMenus(details);
      }

      details.addEventListener('mouseenter', handleOpenIntent);
      details.addEventListener('pointerenter', handleOpenIntent);
      details.addEventListener('focusin', handleOpenIntent);

      var summary = details.querySelector(':scope > summary');

      if (!summary) return;

      summary.addEventListener('mouseenter', handleOpenIntent);
      summary.addEventListener('pointerenter', handleOpenIntent);
      summary.addEventListener('focus', handleOpenIntent);
      summary.addEventListener('click', handleOpenIntent);
    });
  }

  function bindMegaPanelEvents() {
    document.querySelectorAll(SELECTORS.mega).forEach(function (mega) {
      if (mega.dataset.mubligPanelBound === 'true') return;

      mega.dataset.mubligPanelBound = 'true';

      mega.querySelectorAll(SELECTORS.room).forEach(function (room) {
        function handleRoomEnter() {
          activateMegaRoom(room);
        }

        room.addEventListener('mouseenter', handleRoomEnter);
        room.addEventListener('pointerenter', handleRoomEnter);
        room.addEventListener('focusin', handleRoomEnter);
      });

      mega.addEventListener('mouseleave', function () {
        resetMegaRooms(mega);
      });
    });
  }

  function initMubligMenu() {
    setMegaMenuTop();
    bindTopMenuEvents();
    bindMegaPanelEvents();
  }

  function scheduleInit() {
    initMubligMenu();

    window.requestAnimationFrame(function () {
      setMegaMenuTop();
    });

    window.setTimeout(setMegaMenuTop, 150);
  }

  function handleResize() {
    window.clearTimeout(resizeTimer);

    resizeTimer = window.setTimeout(function () {
      initMubligMenu();
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

  window.addEventListener('resize', handleResize);
  window.addEventListener('scroll', setMegaMenuTop, { passive: true });

  document.addEventListener('shopify:section:load', scheduleInit);

  document.addEventListener(
    'pointerenter',
    function (event) {
      if (event.target.closest && event.target.closest(SELECTORS.headerMenu)) {
        setMegaMenuTop();
      }
    },
    true
  );
})();